import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ResponsiveDialogService } from './responsive-dialog.service';
import { PdfBlockReasonCode } from '../models/pdf-analysis-result.model';
import {
  PdfInspectorErrorModalComponent,
  PdfInspectorErrorModalData
} from '../pdf-inspector-error-modal/pdf-inspector-error-modal.component';

/**
 * Centraliza la apertura del modal de error de PDF Inspector (ver ECM-13965) para que los
 * distintos puntos de consumo de `PdfAnalyzerService` (add-documentation, file-document-upload,
 * create-lsd, multiple-documentation-add-dialog) no dupliquen el `MatDialog.open(...)` boilerplate.
 */
@Injectable({ providedIn: 'root' })
export class PdfInspectorErrorModalService {
  constructor(private dialog: MatDialog, private responsiveDialog: ResponsiveDialogService) { }

  /**
   * Abre el modal de error para el `reasonCode` dado.
   * @returns Observable que emite `true` si el usuario eligió "Volver a intentar", `false` si
   *   cerró el modal sin reintentar (botón "×" o click fuera).
   */
  open(reasonCode: PdfBlockReasonCode): Observable<boolean> {
    const data: PdfInspectorErrorModalData = { reasonCode };
    const dialogRef = this.dialog.open(PdfInspectorErrorModalComponent, {
      ...this.responsiveDialog.getConfig('420px'),
      data,
      disableClose: false
    });

    return dialogRef.afterClosed().pipe(map(result => !!result));
  }
}
